const reducerName = '@cityoo-backoffice/spatial/changeDeteced';

export const RESET = `${reducerName}/RESET`;

export const CREATE_CHANGE_DETECTED_START = `${reducerName}/CREATE_CHANGE_DETECTED_START`;
export const CREATE_CHANGE_DETECTED_SUCCESS = `${reducerName}/CREATE_CHANGE_DETECTED_SUCCESS`;
export const CREATE_CHANGE_DETECTED_FAIL = `${reducerName}/CREATE_CHANGE_DETECTED_FAIL`;
